"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Carousel, CarouselContent, CarouselItem } from "@/components/ui/carousel";
const brands = [{
  name: "Gas Safe Register",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615185/img/logo_gas_safe_register.png"
}, {
  name: "NICEIC",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615185/img/logo_niceic.png"
}, {
  name: "Checkatrade",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615185/img/logo_checkatrade.png"
}, {
  name: "TrustATrader",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615185/img/logo_trustatrader.png"
}, {
  name: "SafeContractor",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615185/img/logo_safecontractor.png"
}];
export default function CertifiedByExcellence() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}